import { BasicRequest } from "./basicRequest";

export class UndeleteValidationDefinitionRequest extends BasicRequest{
    public validationDefinitionId! : number;
}